module.exports = __webpack_public_path__ + "img/UI_common_framelabelBYB_01_642adf85a.png";